export const defaultMenuType = 'menu-sub-hidden'; // 'menu-default', 'menu-sub-hidden', 'menu-hidden';
export const defaultStartPath = '/';
export const searchPath = '/search';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;

export const defaultLocale = 'en';
export const defaultDirection = 'ltr';

export const localeOptions = [
    {id: 'en', name: 'English LTR', direction: 'ltr'},
    {id: 'es', name: 'Español', direction: 'ltr'},
    {id: 'enrtl', name: 'English RTL', direction: 'rtl'}
];

export const apiUrl = '/api/hms';

export const appMode = 'theme_radius';
export const themeRadiusStorageKey = 'theme_radius';
export const themeSelectedColorStorageKey = 'theme_selected_color';
export const defaultColor = 'light.blueolympic';
export const colors = [
    'bluenavy',
    'blueyale',
    'blueolympic',
    'greenmoss',
    'greenlime',
    'purplemonster',
    'orangecarrot',
    'redruby',
    'yellowgranola',
    'greysteel'
];
